import { Component, inject, input, OnInit } from '@angular/core';
import { SingleMenuItem } from '../../models/Customer Order model/single-menu-item.model';
import { ExchangeConvertorService } from '../../Services/exchange-convertor.service';
import { LanguageService } from '../../Services/language.service';

@Component({
  selector: 'app-single-item-card',
  templateUrl: './single-item-card.component.html',
  styleUrl: './single-item-card.component.scss'
})
export class SingleItemCardComponent implements OnInit{

  singleItem = input.required<SingleMenuItem>();
  
  amountInUSD: number = 0;
  exchangeRate: number | null = null;
  public languageService  = inject(LanguageService);
  language = this.languageService.getLanguage();

  constructor(private currencyConverterService: ExchangeConvertorService) {}
  ngOnInit(): void {
    this.fetchExchangeRate();
    this.languageService.currentLanguage$.subscribe(() => {
      this.updateTitles();
    });
  }

  fetchExchangeRate(): void {
    this.languageService.currentLanguage$.subscribe((langauge) => {
      switch(langauge){
        case "En":
          this.currencyConverterService.calculateDollar(this.singleItem().priceEn).subscribe({
            next: (priceInUSD) => {
              this.amountInUSD = priceInUSD;
            },
            error: (error) => {
              //console.error('Error calculating dollar value:', error);
            },
          });
         break;
        case "Tr":
          this.currencyConverterService.calculateDollar(this.singleItem().priceTr).subscribe({
            next: (priceInUSD) => {
              this.amountInUSD = priceInUSD;
            },
            error: (error) => {
              //console.error('Error calculating dollar value:', error);
            },
          });
         break;
        case "Ar":
          this.currencyConverterService.calculateDollar(this.singleItem().priceAr).subscribe({
            next: (priceInUSD) => {
              this.amountInUSD = priceInUSD;
            },
            error: (error) => {
              //console.error('Error calculating dollar value:', error);
            },
          });
         break;
      }
    })
  }

  updateTitles(){
    this.language = this.languageService.getLanguage();
  }
  

}
